export function prepareUploadbody(file: File | Blob): FormData {
  const formData = new FormData();
  formData.append('image', file);
  return formData;
}
